import React, { useEffect } from "react";
import FamilyProductParent from "./FamilyProductParent";
import "./FamilyProductView.scss";
import { createMarkup } from "../../../utils/transformer";

const FamilyProductView = ({
  familyProducts,
  familyProductsFilters,
  localConfigurator,
  aggregatedFamilyProducts,
  getAggregatedFamilyProducts,
  user,
  getDefaultFamilyProducts,
}) => {
  useEffect(() => {
    if (localConfigurator.id) {
      user?.id ? getAggregatedFamilyProducts() : getDefaultFamilyProducts();
    }
  }, [user?.id, localConfigurator.id]); //eslint-disable-line

  return (
    <section id="family-product-view">
      <div className="row">
        <div className="col-12 mt-5">
          {localConfigurator?.content?.productFamilies?.title &&
            localConfigurator.content.productFamilies.title !== "" && (
              <h4 className="text-uppercase">
                {localConfigurator.content.productFamilies.title}
              </h4>
            )}
          {localConfigurator?.content?.productFamilies?.text &&
            localConfigurator.content.productFamilies.text !== "" && (
              <div
                dangerouslySetInnerHTML={createMarkup(
                  localConfigurator.content.productFamilies.text,
                )}
              />
            )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="card-columns">
            {familyProductsFilters?.length > 0 &&
              Array.isArray(familyProducts) &&
              familyProductsFilters.map((familyProductId, index) => {
                if (familyProducts?.find((x) => x._id === familyProductId))
                  return (
                    <FamilyProductParent
                      familyProduct={familyProducts?.find(
                        (x) => x._id === familyProductId,
                      )}
                      key={familyProductId + index}
                      familyProductsFilters={familyProductsFilters}
                      aggregatedFamilyProducts={aggregatedFamilyProducts}
                      user={user}
                    />
                  );
                else return "";
              })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FamilyProductView;
